import {useState, useEffect, useRef} from 'react';
import {setChatId, setTypeChat} from "../../redux/actions/chat/chatActions";
import {useDispatch} from "react-redux";

export const useWindowResize = (setIsChatOpen,setShowButtons,setSelectedBack,setCompanies,setCommon) => {
    const dispatch = useDispatch();
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1080);
    const prevWidthRef = useRef(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            const prevWidth = prevWidthRef.current;
            setWindowWidth(currentWidth);
            setIsMobile(currentWidth <= 1080);
            if ((prevWidth < 1080 && currentWidth >= 1080) || (prevWidth >= 1080 && currentWidth < 1080)) {
                if (currentWidth >= 1080) {
                    setIsChatOpen(true);
                    setShowButtons(true);
                    setSelectedBack(false);
                    setCompanies(false);
                    setCommon(false);
                } else {
                    setIsChatOpen(false);
                    setShowButtons(true);
                    setSelectedBack(false);
                    setCompanies(false);
                    setCommon(false);
                }
            }

            prevWidthRef.current = currentWidth; // Обновляем предыдущее значение ширины
        };
        window.addEventListener('resize', handleResize);
        const handleSetSizes = () => {
            const windowWidth = window.innerWidth;
            setWindowWidth(window.innerWidth);
            setIsMobile(window.innerWidth < 1080);
            if (windowWidth >= 1080) {
                setIsChatOpen(true);
                setShowButtons(true);
                setSelectedBack(false);
                setCompanies(false);
                setCommon(false);
            } else {
                setIsChatOpen(false);
                setShowButtons(true);
                setSelectedBack(false);
                setCompanies(false);
                setCommon(false);
            }
        };
        handleSetSizes();

        return () => {
            window.removeEventListener('resize', handleResize)
            dispatch(setChatId(''))
            dispatch(setTypeChat('default'))
        };
    }, []);


    return {windowWidth, isMobile};
};

export default useWindowResize;
